module.exports = __webpack_public_path__ + "static/other/gamePlumbing2.751dfe71.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/gamePlumbing/gamePlumbing2.json
// module id = 2291
// module chunks = 0